<script>
/* eslint-disable */
export default {
	name: 'popup_sucess',
	props: {
		isActiveSucess: {
			type: Boolean,
			required: true,
		},
		popupTitle: {
			type: String,
			required: true,
		},
	},
	methods: {
		popupToggle() {
			// console.log("popupToggle",this.popupTitle)
			let vm = this;
			if (vm.popupTitle === '預約賞車') {
				vm.$emit('update:isActiveSucessfromPop', true);
			} else {
				vm.$emit('update:isActiveSucess', false);
				fbq('trackSingle', '1410978252893251', 'CompleteRegistration');

				fbq('trackSingle', '361601228588748', 'FB CTA | SKM_BMW | btn click-Finished', {
					content_name: '',
				});
				fbq('trackSingle', '738578057123671', 'FB CTA | SKM_BMW | btn click-Finished', {
					content_name: '',
				});
			}
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
